export enum Environment {
  Dev = "deva",
  Uat = "uata",
  Prod = "proda"
}
